import MaterialUIListItem from '@material-ui/core/ListItem';
import { Theme, withStyles } from '@material-ui/core/styles';

const styles = (theme: Theme) => ({
  root: {
    paddingLeft: theme.spacing(2)
  }
});

export const ListItem = withStyles(styles)(MaterialUIListItem) as typeof MaterialUIListItem;
